
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import Messages from '../../shared/UI/Messages/Messages';
import * as actions from '../../store/actions/index';
import moment from 'moment';

class PayrollReport extends Component {

    constructor(props) {
        super(props);
        this.state = { loading: false, error: null };
    }

    componentDidMount() {
        this.props.getRequest();
    }

    actionTemplate = (rowData, column) => {
        //let rowIndex = column.rowIndex;
        return <div>

            <Link to={{
                pathname: `/add-payroll-report/edit/${rowData.requestId}`, state: {
                    ...rowData
                }
            }}>
                <Button type="button" icon="pi pi-pencil" className="p-button-info" />
            </Link>
        </div>;
    }

    statusRender = (rowData, column) => {

        let status = <Button type="button" label="Pending" className="p-button-warning p-button-rounded" ></Button>
        if (rowData.status === null || undefined) {
            status = <Button type="button" label="Saved as Draft" className="p-button-info p-button-rounded" ></Button>
        } else if (rowData.status === 'Approved') {
            status = <Button type="button" label="Approved" className="p-button-success p-button-rounded" ></Button>
        } else if (rowData.status === 'Canceled') {
            status = <Button type="button" label="Canceled" className="p-button-danger p-button-rounded" ></Button>
        } else if (rowData.status === 'Closed') {
            status = <Button type="button" label="Closed" className="p-button-success p-button-rounded" ></Button>
        } else if (rowData.status === 'Rejected') {
            status = <Button type="button" label="Rejected" className="p-button-danger p-button-rounded" ></Button>
        }

        return <div className="actionCenter">
            {status}
        </div>;
    }


    render() {
        const { requestListData } = this.props;
        const data = requestListData && requestListData[0] && requestListData[0].filter(list => list.processId === '1d997738-6764-4dab-adbb-f403cd5ae13b' && list.requestFrom === "My Request") || [];

        return (
            <div className="p-col-12">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <div className="card card-w-title" style={{ position: 'relative' }}>
                    <h1>Payroll Report</h1>
                    <Link to="/add-payroll-report" style={{ position: 'absolute', right: '13px', top: '9px' }}>
                        <Button icon="pi pi-plus" label="Add Payroll Report" />
                    </Link>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <DataTable
                                value={data}
                                responsive
                                className="p-datatable-customers animated fadeIn"
                                rowHover
                                selection={this.state.selectedCustomers}
                                onSelectionChange={e => this.setState({ selectedCustomers: e.value })}
                                paginator
                                rows={10}
                                emptyMessage="No lists found"
                                globalFilter={this.state.globalFilter}>
                                <Column selectionMode="multiple" style={{ width: '3em' }} />
                                <Column field="requestNum" sortable={true} header="Request No." />
                                <Column field="requesterName" sortable={true} header="Requester Name" style={{ width: '180px' }} />
                                <Column field="requestDate" sortable={true} header="Request Date" />
                                <Column field="remark" sortable={true} header="Remarks" />
                                <Column field="pendingWith" sortable={true} header="Pending With" />
                                <Column field="status" sortable={true} header="Status" body={this.statusRender} />
                                <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                            </DataTable>
                        </div>
                    </div>


                </div>


            </div>

        );
    }


}

const mapStateToProps = state => {

    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        loading: state.master.loading,
        error: state.master.error,
        requestListData: state.master.requestListData,
        calendarData: state.master.calendarData
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getRequest: (value) => dispatch(actions.getRequest(value)),
        getCalendarData: (empId, model, fromDate, toDate) => dispatch(actions.getCalendarData(empId, model, fromDate, toDate))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PayrollReport);